import service from "@/request";
import { ApiReturnData, ApiReturnDataByOther } from "@/request/apiInter";
import { SubAccountListItem } from "@/views/Login/_interface";

/** 用户登录 */
export const userLoginGetInfo = (params: {
  phone: string;
  code: string;
  openId?: string;
  unionId?: string;
  accessToken?: string;
  province?: string;
  city?: string;
  needBindVX?: string;
}): Promise<ApiReturnData> => {
  return service({
    url: "/apipc/user/login",
    method: "post",
    data: params
  });
};
/** 用户获取验证码 */
export const getUserPhoneCode = (params: {
  phone: string;
  validateSign: string;
}): Promise<ApiReturnData> => {
  return service({
    url: "/apipc/user/sendSms",
    method: "get",
    params: params
  });
};

/** 获取二维码登录微信配置信息 */
export const getWeChartConfigInfo = (): Promise<ApiReturnData> => {
  return service({
    url: "/apipc/user/loginParam",
    method: "post"
  });
};

/** 获取二维码登录微信配置信息 */
export const postWechatLoginByCode = (params: {
  vxCode: string;
}): Promise<ApiReturnData> => {
  return service({
    url: "/apipc/user/loginByWX",
    method: "post",
    data: params
  });
};

/** 获取可登录子账号列表 */
export const getUserLoginSonAccountListApi = (): Promise<
  ApiReturnDataByOther<SubAccountListItem[]>
> => {
  return service({
    url: "/apipc/user/getChooseShopList",
    method: "get"
  });
};
/** 登录子账号 */
export const postLoginSonAccountApi = (params: {
  mainUserId: number;
}): Promise<ApiReturnDataByOther<any>> => {
  return service({
    url: "/apipc/user/loginChooseShop",
    method: "post",
    data: params
  });
};
